import { IIsiDtoIwsGridManagerClientSettings, IIsiDtoIwsGridManagerClientState, IsiDtoIwsGridManagerClientSettings, IsiGridType } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject";
import { IsiGridPagin } from "../../IsiGridPagin";
import { IsiPagineState } from "../../IsiPagineState";
import { IsiIWSAssociatedViewContext } from "./AssociatedView/IsiIwsAssociatedViewContext";
import { IIsiIwsGridViewContext } from "./IIsiIwsGridViewContext";

export abstract class IsiGridManager {
    /// <summary>
    ///     Classe de gestion de la grille.
    /// </summary>

    _settings: IIsiDtoIwsGridManagerClientSettings;
    _state: IIsiDtoIwsGridManagerClientState;


    //---------------------------------------------------------------
    // Public members
    //---------------------------------------------------------------
    //private _id = "";
    //private type = GridType.Normal;
    //private formPosition = GridPosition.Formular;
    // YLAR 29/08/2012 : on gere le type de sélection pour déterminer si une ligne est sélectionnée
    //private gridSelectionType = GridSelectionType.None;
    // JBUI 48248 : on gere le niveau hierarchique maximum cote client
    private maxRowLevel = 2;
    private _exist = false;
    // JBUI - 29/03/2012 - DYSF49222 : on gere cote client l'identifiant du menu navigation affiche
    private _idNavigationMenu = "";

    private _firstResize = true;

    private _activeCellId = null;

    private _pagin = new IsiGridPagin();

    //---------------------------------------------------------------
    // Private members
    //---------------------------------------------------------------
    private _builded = false;

    //private _header: JQuery;
    //private _container: JQuery = null;
    //private _hasContainer = false;
    private _gridContainer: JQuery = null;
    //private _tableVT: HTMLElement;
    private _expandedRows = [];
    private _isResizingFirstColumn = false;
    private _primaryKeys: any;

    private _contexts: { [key: string]: IIsiIwsGridViewContext; };
    private _mainContext: IIsiIwsGridViewContext;

    constructor(settings: IIsiDtoIwsGridManagerClientSettings, state: IIsiDtoIwsGridManagerClientState) {
        this._settings = settings || IsiDtoIwsGridManagerClientSettings.fromJS({ searchType: IsiGridType.None });
        this._state = state;
        this._contexts = {};
    }

    

    get settings() {
        return this._settings;
    }

    get mainContext() {
        //if (this._state && Object.keys(this._state.states).length) {
        //    return this._state.states[this._state.mainStateId]
        //}
        return this._mainContext;
    }

    get activeCellId() {
        return this._activeCellId;
    }

    set activeCellId(value) {
        this._activeCellId = value;
    }

    get primaryKeys() {
        return this._primaryKeys;
    }

    set primaryKeys(value) {
        this._primaryKeys = value;
    }

    get idNavigationMenu() {
        return this._idNavigationMenu;
    }

    protected get firstResize() {
        return this._firstResize;
    }

    protected set firstResize(value: boolean) {
        this._firstResize = value;
    }

 

    protected get pagin() {
        return this._pagin;
    }

    protected get isResizingFirstColumn() {
        return this._isResizingFirstColumn;
    }

    protected set isResizingFirstColumn(value: boolean) {
        this._isResizingFirstColumn = value;
    }

    protected get gridContainer() {
        return this._gridContainer;
    }

    protected set gridContainer(value: JQuery) {
        this._gridContainer = value;
    }

    //---------------------------------------------------------------
    // Public members
    //---------------------------------------------------------------
    _initialize() {
        /// <summary>
        ///  Indique s'il existe une grille associee a l'application courante.
        /// </summary>
        /// <param name="gridId" type="String">
        ///     Id de la grille.
        /// </param>  
        /// <param name="gridType" type="IsiGridType">
        ///     Indique si la grille est normal, hierarchique ou etendue.
        /// </param> 
        /// <param name="gridPosition" type="IsiGridPosition">
        ///     Indique si la grille est dans le formulaire ou le detail.
        /// </param>  
        this._exist = true;
        this._pagin.bindPagingEvents();

        this._initDomRefs();

        this.initializeOverridable();

    }

    protected initializeOverridable() {

    }

    get exist() {
        return this._exist;
    }

    saveState() {
        ///  <summary>
        ///  Sauve l'etat de l'objet a envoyer au serveur. Il sera charge cote serveur par IsiClientState.IsiLoad.
        ///  </summary>
        var id = 1;
        if (isiApp.appState.paginState) {
            id = isiApp.appState.paginState.id;
        }
        isiApp.appState.paginState = new IsiPagineState(id);
        isiApp.appState.paginState.setExpandedRows(this._expandedRows);
        isiApp.appState.paginState.maxRowLevel = this.maxRowLevel;
        isiApp.appState.paginState.idNavigationMenu = this._idNavigationMenu;

        this._pagin.saveState();
    }

    loadState() {
        ///  <summary>Charge l'etat de l'objet en provenance du serveur.</summary>
        this._expandedRows = isiApp.appState.paginState.expandedRows;
        this.maxRowLevel = isiApp.appState.paginState.maxRowLevel;
        this._idNavigationMenu = isiApp.appState.paginState.idNavigationMenu;
        this._pagin.loadState();
    }



    resize() {
        /// <summary>
        ///     Redimensionne la grille.
        ///     Cette fonction permet de redefinir la taille de la grille affichee sur la page
        ///     afin qu'elle utilise le maximum de surface disponible dans sa zone (DIV).
        /// </summary>

        this._initDomRefs();

       
        //uiCore.log("grid-resize fin");
    }


    dispose() {
        /// <summary>
        ///     Libere la memoire utilise pour la gestion de la pagination de la grille.
        /// </summary>
        if (this._exist) {
            this._pagin.dispose();
        }

        //this._header = null;
        //this._container = null;
        this._gridContainer = null;
        this._expandedRows = null;
        //this._tableVT = null;

        this.disposeOverridable();
    }

    protected disposeOverridable() {

    }

    //---------------------------------------------------------------
    // Private members
    //---------------------------------------------------------------
    protected _initDomRefs() {
        /// <summary>
        ///     Private : Initialise les acces aux elements du DOM.
        /// </summary>

        if (this._exist && !this._builded) {

           this._builded = this.initDomRefsOverridable();


        }
    }

    protected initDomRefsOverridable() {
        return true;
    }

   
   
    hide() {

    }

    fadeIn() {

    }


    registerContext(context: IIsiIwsGridViewContext, isMain: boolean) {
        this._contexts[context.id] = context;

        if (isMain) {
            this._mainContext = context;
            this._initialize();
            this._pagin.initPaging(this.mainContext.gridViewId);
        }
    }

    getContext(id: string) {
        return this._contexts[id];
    }

    checkDetailGridValidity(gridContext: IsiIWSAssociatedViewContext) {
        let atLeastOneCheckedRow = gridContext.allLinesSelected;

        if (!atLeastOneCheckedRow) {
            if (gridContext.hasSelectedRows()) {
                atLeastOneCheckedRow = true;
            } else if (gridContext?.associatedViewState?.activeRow) {
                gridContext.selectedRows.rows.push(gridContext.associatedViewState.activeRow)
                atLeastOneCheckedRow = true;
            }
        }

        return atLeastOneCheckedRow;
    }

    cellDoubleClicked(context: IIsiIwsGridViewContext, cellId: string): Promise<boolean> {
        return context.cellDoubleClicked(cellId);
    }
}
